import { ArrowRight, FileCheck, Shield, Zap } from "lucide-react";
import heroBg from "@/assets/hero-bg.webp";

const stats = [
  { icon: FileCheck, label: "Documentos procesados", value: "500K+" },
  { icon: Shield, label: "Cumplimiento normativo", value: "100%" },
  { icon: Zap, label: "Semanas de implementación", value: "4–6" },
];

const Hero = () => (
  <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
    {/* Background */}
    <div className="absolute inset-0">
      <img
        src={heroBg}
        alt=""
        className="w-full h-full object-cover"
        width={1600}
        height={900}
        // @ts-expect-error fetchpriority is valid HTML attr
        fetchpriority="high"
        decoding="async"
      />
      <div className="absolute inset-0 hero-overlay opacity-80" />
    </div>

    <div className="container relative z-10 pt-28 pb-20">
      <div className="max-w-3xl">
        <div className="hero-fade-in">
          <span className="inline-flex flex-wrap items-center gap-x-2 gap-y-1 rounded-xl border-2 border-primary bg-primary/20 px-5 py-3 shadow-lg shadow-primary/30 backdrop-blur-sm mb-7">
            <Shield size={18} className="text-primary shrink-0" aria-hidden="true" />
            <strong className="text-sm sm:text-base font-extrabold uppercase tracking-wide text-primary-foreground">
              DocuWare Authorized Partner
            </strong>
            <span className="text-sm sm:text-base font-bold text-primary-foreground">
              · Latinoamérica · Centroamérica · Estados Unidos
            </span>
          </span>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-primary-foreground mb-6">
            Transformación en{" "}
            <span className="text-gradient">Gestión Documental</span>
          </h1>

          <p className="text-lg sm:text-xl text-primary-foreground/70 max-w-2xl mb-10 leading-relaxed">
            Digitalización, automatización de procesos y conservación de documentos con DocuWare
            para empresas en Latinoamérica, Centroamérica y Estados Unidos, con cumplimiento
            normativo y fiscal adaptado a cada país.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contacto"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-7 py-3.5 text-base font-semibold text-primary-foreground hover:bg-primary/90 transition-colors"
            >
              Agendar Consultoría <ArrowRight size={18} />
            </a>
            <a
              href="#servicios"
              className="inline-flex items-center justify-center gap-2 rounded-lg border border-primary-foreground/20 px-7 py-3.5 text-base font-semibold text-primary-foreground hover:bg-primary-foreground/10 transition-colors"
            >
              Nuestros Servicios
            </a>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-16 hero-fade-in-delayed">
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-4 rounded-xl border border-primary-foreground/10 bg-primary-foreground/5 backdrop-blur-sm p-5">
              <stat.icon size={28} className="text-primary shrink-0" />
              <div>
                <p className="text-2xl font-bold text-primary-foreground">{stat.value}</p>
                <p className="text-sm text-primary-foreground/60">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
